import { render, staticRenderFns } from "./ScalablePsds.vue?vue&type=template&id=589c033a&scoped=true&"
import script from "./ScalablePsds.vue?vue&type=script&lang=js&"
export * from "./ScalablePsds.vue?vue&type=script&lang=js&"
import style0 from "./ScalablePsds.vue?vue&type=style&index=0&id=589c033a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589c033a",
  null
  
)

export default component.exports